import { NavParams, Events } from 'ionic-angular';
import { Observable } from 'rxjs';
import { IlsProvider } from '../../providers/ils/ils';
import { PatronDetails } from '../../providers/patron/patron';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { AppState, patronFields } from '../../config/state';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, NgForm, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { PatronProvider } from '../../providers/patron/patron';
import { from } from 'rxjs/observable/from';
import { LocationsProvider } from '../../providers/locations/locations';
import { PatronFieldsProvider } from '../../providers/patronFields/patronFields.service';
import moment from 'moment';

@Component({
  selector: 'page-co-patron-detail-form',
  templateUrl: 'co-patron-detail-form.html',
  providers: [
    PatronFieldsProvider
  ]
})
export class CoPatronDetailFormPage {
  @ViewChild('form') form: NgForm;
  @Input('patron') patron: PatronDetails;
  public formGroup: FormGroup;
  public branches$: Observable<any[]>;
  public formOptions$: Observable<any[]>;
  public menuSide: string = "left";
  public titleSegment: string ='';
  public submitting = false;
  public patronFields: patronFields = {};
  public minNewExpiryDate = "";
  constructor(
    private _formBuilder: FormBuilder,
    private patronProvider: PatronProvider,
    private ilsProvider: IlsProvider,
    private state : AppState,
    private toast : ToastAlertsProvider,
    private navParams: NavParams,
    private events: Events,
    private _locationsProdiver: LocationsProvider,
    private _patronFields: PatronFieldsProvider
  ) {
    this.patronFields = this._patronFields.getFields();
    this.state.burgerMenu && this.state.burgerMenu.menuSide ? this.menuSide = this.state.burgerMenu.menuSide : this.menuSide = "hidden";
    this.formGroup = this.initFormGroup();
    this.minNewExpiryDate = moment().add(1, 'days').format("YYYY-MM-DD");
    this.branches$ = from(
      this._locationsProdiver.getLocations())
      .map(locations => {
       return locations.filter((x) => x.polarisId && x.polarisId != null).map((location) =>  {
        return {
         code: location.polarisId,
         name: location.name
       }})
      });
    this.formOptions$ = from(this.patronProvider.getPatronFormOptions());

    if (this.navParams.data.patron) {
      this.patron = this.navParams.data.patron;
    }

    if (this.navParams.data.segment) {
        switch (this.navParams.data.segment) {
          case 'name':
            this.titleSegment = 'Name'
            break;

          case 'address':
            this.titleSegment = 'Address'
            break;

          case 'contact':
            this.titleSegment = 'Contact'
            break;

          case 'homeBranch':
            this.titleSegment = 'Home Branch'
            break;

          case 'expires':
            this.titleSegment = 'Expiry Date'
            break;

          case 'dob':
            this.titleSegment = 'Date of Birth'
            break;

          case 'additionalInfo':
            this.titleSegment = 'Additional Information'
            break;

          case 'pin':
            this.titleSegment = this.patronFields.pin.title;
            break;

          default:
            break;
        }
    }

    this.formGroup.patchValue(this.patron);
    this.formGroup.patchValue({currentPin: '', pin: '', repeatPin: ''});

    this.formGroup.valueChanges.subscribe((val: any) => console.log(val)); // testing

    this.formGroup.get('homeBranch').valueChanges.subscribe((val: any) => {
      if (val) {
        this.formGroup.patchValue({ homeBranchId: val.code, branch: val.name })
        this.formGroup.get("homeBranchId").markAsTouched();
      }
    });
  }

  initFormGroup(): FormGroup {
    const formGroup: FormGroup = this._formBuilder.group({
      firstName: [null],
      lastName: [null],
      street: [null],
      city: [null],
      state: [null],
      zip: [null],
      email: [null, [this.emailOrEmptyValidator]],
      phone: [null],
      branch: [null],
      homeBranch: [null],
      homeBranchId: [null],
      residentCategory: [null],
      manualBlock: [null],
      patronType: [null],
      cardCampaign: [null],
      noticePreference: [null],
      dob: [null],
      cityState: [null],
      currentPin: [null],
      pin: [null],
      repeatPin: [null],
      expires: [null],
      user1: [null],
      user2: [null],
      user3: [null],
      user4: [null],
      user5: [null]
    }, {validator: this.pinValidator(this.state.staff)});
    return formGroup;
  }

  private pinValidator(staff: boolean): ValidatorFn {
    return function(group: AbstractControl): ValidationErrors {
      const currentPin = group.get('currentPin'),
        pin = group.get('pin'),
        repeatPin = group.get('repeatPin');
      if(staff && (pin.dirty || repeatPin.dirty) && (!pin.value || !repeatPin.value)) {
        return { 'pin': true };
      } else if(!staff && (currentPin.dirty || pin.dirty || repeatPin.dirty) && (!currentPin.value || !pin.value || !repeatPin.value)) {
        return { 'pin': true };
      } else if(pin.value !== repeatPin.value) {
        return { 'repeatPin': true };
      }
      return null;
    }
  }

  private emailOrEmptyValidator(control: AbstractControl): ValidationErrors {
    if (!control.value) {
      return null;
    }

    return Validators.email(control);
  }

  compareBranchesFn(e1: any, e2: any): boolean {
    return e1 && e2 ? e1.code === e2.code : e1 === e2;
  }
  compareOptionFn(e1: any, e2: any): boolean {
    return e1 && e2 ? e1 === e2 : e1 === e2;
  }

  getDirtyFields(fields: any) {
    return fields.filter((field: any) => field.dirty)
  }

  submitInfoChange(){
    if (this.submitting || this.formGroup.pristine || this.formGroup.invalid) {
      return;
    }
    const barcode = this.patron.barcode;
    let pin = null;
    if(!this.state.staff) {
      pin = this.formGroup.get('pin').dirty ? this.formGroup.get('currentPin').value : this.patron.pin;
    }

    const { street, city, state, cityState, zip, ...patronFields } = this.formGroup.controls;
    const details: any = {};

    Object.keys(patronFields).forEach(function(key, index) {
      if (patronFields[key].touched) {
        details[key] = patronFields[key].value;
      }
    });

    const addressIsDirty = [ street, city, state, cityState, zip ].some((field) => field.dirty);
    if (addressIsDirty) {
      // format address query with white space removed from the postcode
      details.address = [`${street.value}`, `${city.value}`, `${state.value} ${zip.value.replace(/ /g, '')}`];
    }

    this.formGroup.disable();
    this.submitting = true;

    const patron = {
      ...this.patron,
      ...details,
      street: street.value,
      city: city.value,
      state: state.value,
      cityState: cityState.value,
      zip: zip.value.replace(/ /g, '') // remove white space
    };

    if (!this.formGroup.get('pin').dirty) delete patron.pin;

    // @TODO: COM-636 Just send details as the third argument - only send what has changed and let the cloud function do the merging
    if (this.state.demo) {
      this.state.refreshPatron = true;
      this.formGroup.enable();
      this.submitting = false;
      this.toast.triggerToast('Changes saved','','success', 3000);
      this.events.publish('patronEvent', patron);
      setTimeout(() => {
        this.state.nav.pop(patron);
      }, 1500);
    } else {
      from(this.patronProvider.updatePatronDetails(barcode, pin, patron )).subscribe(
        (res) => {
          if (res.status) {
            this.state.refreshPatron = true;
            this.formGroup.enable();
            this.submitting = false;
            this.toast.triggerToast('Changes saved','','success', 3000);
            this.events.publish('patronEvent', patron);
            setTimeout(() => {
              this.state.nav.pop(patron);
            }, 1500);
          } else {
            this.toast.triggerToast(res.message ? res.message : 'Changes could not be saved, sorry', '', 'error');
            setTimeout(() => {
              this.state.nav.pop(patron);
            }, 500);
          }
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/co-patron-detail-form/co-patron-detail-form.ts